module.exports = __webpack_public_path__ + "img/proapp01.07d31ec8.jpg";